import React, { useState, useEffect } from 'react';
import { Offcanvas } from 'react-bootstrap';
import './../lobby.css';

export default function ServerNotifications({
    show,
    onHide,
    client,
    session,
    sessionTimeoutCheck,
    setShowServerNotifications
}) {
    const [serverNotifications, setServerNotifications] = useState([]);
    const [senderAccounts, setSenderAccounts] = useState({});
    const [hasShownThisSession, setHasShownThisSession] = useState(() => {
        try {
            return sessionStorage.getItem('hasShownNotifications') === 'true';
        } catch (error) {
            console.warn('Unable to access sessionStorage:', error);
            return false;
        }
    });

    useEffect(() => {
        if (hasShownThisSession && show) {
            setShowServerNotifications(false);
        }

        const fetchNotifications = async () => {
            try {
                // Fetch the last 100 notifications in a single call
                const result = await client.listNotifications(session, 10);
                if (!result.notifications || result.notifications.length === 0) {
                    setServerNotifications([]);
                    return;
                }
                console.log(result.notifications)
                setServerNotifications(result.notifications);

                console.log(result.notifications)
                setServerNotifications(result.notifications);

                // Delete notifications after viewing them
                if (result.notifications.length > 0) {
                    const notificationIds = result.notifications.map(n => n.id);
                    console.log(notificationIds);
                    try {
                        await client.deleteNotifications(session, notificationIds);
                        console.log('Notifications deleted:', notificationIds.length);
                    } catch (deleteError) {
                        console.error("Failed to delete notifications:", deleteError);
                    }
                }

                // Get unique sender IDs from this batch
                const senderIds = [...new Set(
                    result.notifications
                        .filter(n => n.sender_id)
                        .map(n => n.sender_id)
                )];

                if (senderIds.length > 0) {
                    try {
                        const accounts = await client.getUsers(session, senderIds);
                        setSenderAccounts(accounts.users.reduce((acc, user) => {
                            acc[user.id] = user;
                            return acc;
                        }, {}));
                    } catch (error) {
                        console.error("Failed to fetch sender accounts:", error);
                    }
                }
            } catch (error) {
                console.error("Failed to fetch server notifications:", error);
                // Only call sessionTimeoutCheck for actual authentication errors (401, 403)
                if (error.code === 16 || error.message?.includes('UNAUTHENTICATED') || error.message?.includes('session')) {
                    sessionTimeoutCheck();
                }
            }
        };

        if (!hasShownThisSession) {
            console.log("fetching notifications");
            fetchNotifications();
            try {
                sessionStorage.setItem('hasShownNotifications', 'true');
            } catch (error) {
                console.error("Failed to set sessionStorage:", error);
            }
        }
    }, [client, session, sessionTimeoutCheck, hasShownThisSession, setShowServerNotifications, show]);

    if (hasShownThisSession) {
        return null;
    }

    return (
        <Offcanvas
            show={show}
            onHide={onHide}
            placement="end"
            style={{ backgroundColor: '#1B3A5D' }}
        >
            <Offcanvas.Header className="offcanvas-header-container" closeButton style={{ justifyContent: 'center' }}>
                <Offcanvas.Title
                    style={{
                        fontFamily: 'Truculenta, sans-serif',
                        fontSize: '40px',
                        fontWeight: 'bold',
                        color: 'white',
                    }}
                >
                    Latest Notifications
                </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {serverNotifications.map((notification, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: '#2B4A6D',
                                padding: '15px',
                                borderRadius: '8px',
                                color: 'white'
                            }}
                        >
                            <h3 style={{ color: '#00D1FF', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {notification.sender_id && senderAccounts[notification.sender_id]?.avatar_url && (
                                    <img
                                        src={senderAccounts[notification.sender_id].avatar_url}
                                        alt="Sender avatar"
                                        style={{
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                )}
                                {(notification.code === 100) ? '💀BONEZ💀 ' : ''}
                                {(notification.code === 102 || notification.code === 103) ? ' 🦴' : ''}
                                {(notification.code === 104) ? '🏆 ' : ''}
                                {(notification.code === 105) ? '✌️ ' : ''}
                                {(notification.code === 1001) ? '💰 ' : ''}
                                {(notification.code === -2 || notification.code === -3) ? (
                                    <a
                                        href="https://zoombies.world/auth/friends"
                                        style={{ color: 'inherit', textDecoration: 'none' }}
                                    >
                                        {notification.subject}
                                    </a>
                                ) : notification.subject}
                                {(notification.code === 102) ? <span><span style={{ color: '#999' }}>to </span>{senderAccounts[notification.sender_id]?.username}</span> : ''}
                                {(notification.code === 103) ? <span><span style={{ color: '#999' }}>from </span>{senderAccounts[notification.sender_id]?.username}</span> : ''}
                                {(notification.code === 105) ? (
                                    <>
                                        {` ${(notification.content?.potWin || 0).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}`}
                                        {notification.content?.type === 'zoom' ?
                                            ' 💰 chipz'
                                            : ' 🦴 bonez'}
                                    </>
                                ) : ''}
                                {(notification.code === 1001) ? (
                                    <>
                                        {` +${(notification.content?.chipzAmount || 0).toLocaleString('en-US')} Chipz`}
                                    </>
                                ) : ''}
                            </h3>
                            {/* MIGHT ADD this later <p>{notification.subject}</p> */}
                            <small style={{ color: '#999' }}>
                                {new Date(notification.create_time).toLocaleString()}
                            </small>
                        </div>
                    ))}
                    {serverNotifications.length === 0 && (
                        <p style={{ color: 'white', textAlign: 'center' }}>
                            No notifications at this time
                        </p>
                    )}
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
}